import React, { useState, useEffect, Fragment } from 'react'
import { connect } from 'react-redux'
import { Modal, Button, Tab, Row, Col, Nav } from 'react-bootstrap'

import ChartReviewNotes from './ChartReviewNotes'

import { addChartReviewNote, editChartReviewNote } from '../reducers/chartNotesReducer'

import '../style.css'


const ChartReviewNotesModal = (props) => {
  const { chartReviewNotes, notesSection, show, toggleShowChartReviewNotesModal, reviewDataManagerNotes } = props

  const [ selectedNotesSection, setSelectedNotesSection ] = useState(notesSection || 'General')
  const [ tabLocation, setTabLocation ] = useState('left side')

  useEffect(() => setSelectedNotesSection(notesSection || 'General'), [notesSection])

  useEffect(() => {
    const handleResize = () => {
      if (reviewDataManagerNotes) {
        if (window.innerWidth < 992) {
          return setTabLocation('top')
        }

        if (window.innerWidth >= 992) {
          return setTabLocation('left side')
        }
      }
    }
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [reviewDataManagerNotes])

  const chartSections = [
    'General',
    'Demographics',
    'Hospital Admission',
    'Infection/Microbiology',
    'Antibiotics',
    'Outcome',
  ]

  return (
    <Fragment>
      <Modal
        show={show}
        onHide={() => toggleShowChartReviewNotesModal(!show)}
        dialogClassName="modal-90w"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {selectedNotesSection ?
              `Chart Notes: ${selectedNotesSection}`
              :
              'Chart Notes: General'
            }
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {reviewDataManagerNotes ?
            <p>
              The PROVE Data Manager has submitted a data validation request on this patient chart. Please <span className="data-manager-notes-modal-highlight">review</span> the notes in each section below, <span className="data-manager-notes-modal-highlight">and respond</span> to each note by typing a response into the <span className="data-manager-notes-modal-highlight">'Add a new note'</span> field at the bottom, then clicking the <span className="data-manager-notes-modal-highlight">'Save Note'</span> button. You can navigate to the notes for the different sections of the chart by clicking on the name of the section on the {tabLocation} of this panel. Sections that contain notes are <span className="data-manager-notes-modal-highlight">highlighted in red</span>. If the chart needs to be modified as a result of a data validation request, please mark the chart as <span className="data-manager-notes-modal-highlight">'Requires Revisions'</span> to send the chart back to the original abstractor.
            </p> :
            null
          }
          <Tab.Container 
            onSelect={(key) => setSelectedNotesSection(key)}
            activeKey={selectedNotesSection || 'General'}
          >
            <Row>
              <Col lg={3} sm={12}>
                <Row>
                  <Nav fill>
                    {chartSections.map(section => {
                      const noteCount = chartReviewNotes && Array.isArray(chartReviewNotes[section]) ? chartReviewNotes[section].length : 0
                      return (
                        <Col xs={12} key={'nav-item-' + section}>
                          <Nav.Item>
                            <Nav.Link eventKey={section}>
                              <span style={noteCount > 0 && reviewDataManagerNotes ? { color: 'red' } : null }>
                                {section} ({noteCount})
                              </span>
                            </Nav.Link>
                          </Nav.Item>
                        </Col>
                      )
                    })}

                    {/* {chartReviewNotes['ADR'] && Object.keys(chartReviewNotes['ADR']).length ?
                      <>
                        <div className='adr-notes-divider'>
                          ADRs
                        </div>
                        {Object.keys(chartReviewNotes['ADR']).map(adverseEvent => {
                          return (
                            <Col xs={12} key={'nav-item-' + adverseEvent}>
                              <Nav.Item>
                                <Nav.Link eventKey={adverseEvent}>
                                  {adverseEvent}
                                </Nav.Link>
                              </Nav.Item>
                            </Col>
                          )
                        })}
                      </>
                      :
                      null
                    } */}
                  </Nav>
                </Row>

              </Col>

              <Col lg={9} sm={12} style={{ borderLeft: '1px solid black' }}>
                <Tab.Content>
                  {chartSections.map(section => {
                    return (
                      <Tab.Pane
                        key={'tab-pane-' + section}
                        eventKey={section}
                        title={section}
                      >
                        
                        <ChartReviewNotes 
                          notes={chartReviewNotes[section] || []} 
                          section={section}
                          addChartReviewNote={props.addChartReviewNote}
                          editChartReviewNote={props.editChartReviewNote}
                          readOnly={props.readOnly}
                        />
                      </Tab.Pane>
                    )
                  })}

                  {/* {chartReviewNotes['ADR'] && Object.keys(chartReviewNotes['ADR']).length ?
                    <>
                      {Object.keys(chartReviewNotes['ADR']).map(adverseEventName => {
                        return (
                          <Tab.Pane
                            key={'tab-pane-' + adverseEventName}
                            eventKey={adverseEventName}
                            title={adverseEventName}
                          >
                            <ChartReviewNotes
                              notes={chartReviewNotes['ADR'][adverseEventName].notes || []}
                              section='ADR'
                              adverseEventUrl={chartReviewNotes['ADR'][adverseEventName].url}
                              adverseEventName={adverseEventName}
                              addChartReviewNote={props.addChartReviewNote}
                              editChartReviewNote={props.editChartReviewNote}
                              noNotesMessage="No requests have been made yet for this ADR"
                              saveButtonText="Save and Submit"
                              formLabel="Enter a response"
                              formPlaceholder="Enter a response"
                            />
                          </Tab.Pane>
                        )
                      })}
                    </>
                    :
                    null
                  } */}
                </Tab.Content>
              </Col>
            </Row>
          </Tab.Container>
        </Modal.Body>

        <Modal.Footer>
          <Button onClick={() => toggleShowChartReviewNotesModal(!show)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </Fragment>
  )
}

const mapStateToProps = (state) => {
  return {
    chartReviewNotes: state.chartNotesReducer.chartReviewNotes,
  }
}

const mapDispatchToProps = {
  addChartReviewNote,
  editChartReviewNote,
}

export default connect(mapStateToProps, mapDispatchToProps)(ChartReviewNotesModal)
